var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSortBy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.15382 11.7897H2.78776V9.78971H7.15382V11.7897ZM29.2122 11.7897H17.5302V9.78971H29.2122V11.7897Z",
    fill: "#D2464F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8462 21.21L29.2122 21.21L29.2122 23.21L24.8462 23.21L24.8462 21.21ZM2.78776 21.21L14.4698 21.21L14.4698 23.21L2.78776 23.21L2.78776 21.21Z",
    fill: "#D2464F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0605 13.7256C14.6832 13.7256 15.9987 12.4101 15.9987 10.7874C15.9987 9.16474 14.6832 7.84929 13.0605 7.84929C11.4378 7.84929 10.1224 9.16474 10.1224 10.7874C10.1224 12.4101 11.4378 13.7256 13.0605 13.7256ZM13.0605 15.7256C15.7878 15.7256 17.9987 13.5147 17.9987 10.7874C17.9987 8.06017 15.7878 5.84929 13.0605 5.84929C10.3333 5.84929 8.12239 8.06017 8.12239 10.7874C8.12239 13.5147 10.3333 15.7256 13.0605 15.7256Z",
    fill: "#D2464F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9395 19.2741C17.3168 19.2741 16.0013 20.5895 16.0013 22.2122C16.0013 23.8349 17.3168 25.1504 18.9395 25.1504C20.5622 25.1504 21.8776 23.8349 21.8776 22.2122C21.8776 20.5895 20.5622 19.2741 18.9395 19.2741ZM18.9395 17.2741C16.2122 17.2741 14.0013 19.485 14.0013 22.2122C14.0013 24.9395 16.2122 27.1504 18.9395 27.1504C21.6667 27.1504 23.8776 24.9395 23.8776 22.2122C23.8776 19.485 21.6667 17.2741 18.9395 17.2741Z",
    fill: "#D2464F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSortBy);
export default __webpack_public_path__ + "static/media/ic-sort-by.e16cdbdb6c0450d0dad381ebea8e9c6d.svg";
export { ForwardRef as ReactComponent };